import { render } from "./SecuritiesInvestors.vue?vue&type=template&id=ae953d4c&scoped=true&ts=true"
import script from "./SecuritiesInvestors.vue?vue&type=script&lang=ts"
export * from "./SecuritiesInvestors.vue?vue&type=script&lang=ts"

import "./SecuritiesInvestors.vue?vue&type=style&index=0&id=ae953d4c&scoped=true&lang=scss"

import exportComponent from "/Users/pradipdobariya/Documents/projects/DMA Global/caprock-merchant-old/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae953d4c"]])

export default __exports__